// Story 3.7 — mobile-fidelity tier detection.
//
// Returns true when the viewport is ≤ 768px (Tailwind's `md:` boundary
// + the standard mobile/desktop divide). Consumers pass the value to
// `<RevealCeremony mobileFidelity={...}>` per UX spec L1478 so the
// orchestrator can reduce particle count + disable holographic
// parallax on phones that risk dropped frames.
//
// Story 6.6 layered the runtime perf-detector on top: when the reveal
// ceremony drops frames on a real device, the FPS guard latches a
// session-scoped degrade flag (sessionFidelityStore). `useEffectiveMobile
// Fidelity()` below ORs that flag into the viewport signal — this is the
// "ORs into this prop at the consumer level" this comment always promised.

import { useMatchMedia } from "../../lib/useMatchMedia";
import { useSessionFidelityDegraded } from "./sessionFidelityStore";

export function useMobileFidelity(): boolean {
  return useMatchMedia("(max-width: 768px)");
}

/** The fidelity a ceremony should actually render at: the reduced mobile-
 *  fidelity tier when EITHER the viewport is phone-sized (Story 3.7) OR
 *  the session has been auto-degraded after dropped frames (Story 6.6).
 *  Consumers pass this to `<RevealCeremony mobileFidelity={...}>`. */
export function useEffectiveMobileFidelity(): boolean {
  const viewportMobile = useMobileFidelity();
  const sessionDegraded = useSessionFidelityDegraded();
  return viewportMobile || sessionDegraded;
}
